import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

import closeIcon from 'assets/icons/close-button.svg';
import Button from 'components/Button';
import IconButton from 'components/IconButton';
import ImageSwitch from 'components/ImageSwitch';

import filtersIcon from './assets/filters.svg';
import filtersActiveIcon from './assets/filters_active.svg';

import {FilterForStore} from 'utils/filters';

import './styles.css';

const OpenedContext = React.createContext({
  filtersOpened: false,
  toggleFilters: () => {}
});

const ListContentContent = ({children}) => (
  <div className="ListContent__content">{children}</div>
);

const ListContentFilters = ({children}) => (
  <OpenedContext.Consumer>
    {({filtersOpened, toggleFilters}) => (
      <div
        className={classNames('ListContent__filters', {
          'ListContent__filters--active': filtersOpened
        })}>
        <div className="ListContent__filters__header colab-bold colab-centered-v colab-sidepadding-2 colab-row-space-between">
          <span>Filter</span>
          <IconButton
            src={closeIcon}
            alt="Close Filters"
            onClick={toggleFilters}
          />
        </div>
        {children}
      </div>
    )}
  </OpenedContext.Consumer>
);

interface ListContentProps {
  filters: FilterForStore;
  setFilter?: (field, value) => void;
  initialFilters: FilterForStore;
  navigationExtraElement?: React.ComponentType;
  className?: string;
}

class ListContent extends React.Component<ListContentProps> {
  state = {
    filtersOpened: false
  };

  static Content = ListContentContent;
  static Filters = ListContentFilters;

  toggleFiltersSideMenu = () => {
    this.setState({filtersOpened: !this.state.filtersOpened});
  };

  render() {
    const {
      children,
      className,
      navigationExtraElement,
      filters,
      setFilter
    } = this.props;
    const filtersCount = Object.keys(
      _.omitBy(filters, (value, key) =>
        _.isEqual(this.props.initialFilters[key], value)
      )
    ).length;

    const filtersSelected = filtersCount > 0;
    const NavigationExtraElement: any = navigationExtraElement || (() => null);

    return (
      <div className={classNames('ListContent', className)}>
        <div className="ListContent__navigation colab-centered-v colab-sidepadding-1">
          <NavigationExtraElement filters={filters} setFilter={setFilter} />
          <Button
            onClick={this.toggleFiltersSideMenu}
            className={classNames('ListContent__filtersButton', {
              'ListContent__filtersButton--selected': filtersSelected,
              'ListContent__filtersButton--opened':
                this.state.filtersOpened && !filtersSelected
            })}>
            <ImageSwitch
              src={filtersIcon}
              srcActive={filtersActiveIcon}
              active={filtersSelected}
            />
            <span>{filtersSelected && filtersCount} Filters</span>
          </Button>
        </div>
        <OpenedContext.Provider
          value={{
            filtersOpened: this.state.filtersOpened,
            toggleFilters: this.toggleFiltersSideMenu
          }}>
          {children}
        </OpenedContext.Provider>
      </div>
    );
  }
}

export default ListContent;
